import React from 'react'
import style from '../../style.module.less'
import { corpImage } from '@components/Hotel/util'
import { InfoCircleFilled } from '@ant-design/icons'
import { Flex } from 'hljd'

const getHallCover = (cover_url, items) => {
  if (cover_url) return corpImage(cover_url, '100:64', 100)

  return Array.isArray(items) && items[0] && items[0].url
    ? corpImage(items[0].url, '100:64', 100)
    : ''
}

export default store => [
  {
    title: 'ID',
    dataIndex: 'id',
    width: 40
  },
  {
    title: '场地名称',
    dataIndex: 'name',
    width: 120,
    render: (_, record) => {
      return (
        <div>
          <div>{record.name}</div>
          {record.sensitive_tip && (
            <Flex className={style.bannedWords}>
              <InfoCircleFilled style={{ marginRight: 4, marginTop: 3 }} />
              {record.sensitive_tip}
            </Flex>
          )}
        </div>
      )
    }
  },
  {
    title: '封面图',
    dataIndex: 'items',
    width: 180,
    render: (text, record) => {
      let { id, cover_url, vertical_cover_url, items } = record
      // vertical_cover_url = getImageViewLink('//qnm.hunliji.com/o_1dgm4jgmc1u7fubicf78fu1o8cl.jpg')
      items = items || []
      const { keys } = store
      const img = getHallCover(cover_url, items)
      const vertical_img = corpImage(vertical_cover_url, '1:1', 64)

      const setVertical = (
        <a
          style={{ color: '#448AFC' }}
          // onClick={() => store.showVerticalImgModal({ id, cover_path: img })}
          onClick={store.edit(id)}
        >
          设置竖图
        </a>
      )

      if (keys == 2) {
        return (
          <div className={style.sit_ting}>
            <div className={style.sit_imgs}>
              {img && (
                <div className={style.sit_img}>
                  <img src={img} />
                  <em>审核中</em>
                </div>
              )}
              {vertical_img ? (
                <div className={style.sit_img}>
                  <img src={vertical_img} />
                  <em>审核中</em>
                </div>
              ) : (
                <div>{setVertical}</div>
              )}
            </div>
          </div>
        )
      }

      if (keys == 3) {
        return (
          <div className={style.sit_ting}>
            <div className={style.sit_imgs}>
              <div className={style.sit_img}>
                <img src={img} />
                <em>审核未通过</em>
              </div>
              {vertical_img ? (
                <div className={style.sit_img}>
                  <img src={vertical_img} />
                  <em>审核未通过</em>
                </div>
              ) : (
                <div>{setVertical}</div>
              )}
            </div>
          </div>
        )
      }

      return (
        <div className={style.sit_ting}>
          <div className={style.sit_imgs}>
            <div className={style.sit_img}>
              <img src={img} />
            </div>
            {vertical_img ? (
              <div className={style.sit_img}>
                <img src={vertical_img} />
              </div>
            ) : (
              <div>{setVertical}</div>
            )}
          </div>
        </div>
      )
    }
  },
  {
    title: '场地信息',
    dataIndex: 'info',
    width: 160,
    render: (o, { hall_type, area, pillar, height }) => {
      return (
        <>
          <div>面积：{area}㎡</div>
          {hall_type == 1 && <div>{pillar || '无'}柱</div>}
          {hall_type == 1 && <div>层高：{height}m</div>}
        </>
      )
    }
  },
  {
    title: '桌数信息',
    dataIndex: 'max_table_num',
    width: 120,
    render: (max, { hall_type }) => {
      return <>{hall_type == 1 && <span>最多{max}桌</span>}</>
    }
  },
  {
    title: '宴会厅特色',
    dataIndex: 'service_option_desc',
    width: 220
  },
  {
    title: '创建时间',
    dataIndex: 'created_at',
    width: 130,
    sorter: true
  },
  {
    title: '更新时间',
    dataIndex: 'updated_at',
    width: 130,
    sorter: true
  },
  {
    title: '操作',
    dataIndex: 'operate',
    width: 150,
    render: (operation, { id }) => {
      const { keys } = store
      return (
        <div className={style.buttons}>
          <a onClick={store.edit(id)}>编辑</a>

          {(keys == 1 || keys == 4) && (
            <a onClick={store.menufromsale(id)}>{keys == 1 ? '下' : '上'}架</a>
          )}

          <a onClick={store.delLive(id)} className={style.red}>
            删除
          </a>
        </div>
      )
    }
  }
]
